// en.js
const en_US = {
  首页: 'Home Page',
  收藏: 'Collect',
  home: {
    'GLOBAL INDUSTRIAL INTELLIGENCE TRADING PLATFORM': 'GLOBAL INDUSTRIAL INTELLIGENCE TRADING PLATFORM',
    设备分类: 'Device Category',
    请输入内容: 'Please enter content',
    请输入关键词: 'Please enter keywords',
    搜索: 'Search',
    供应大厅: 'Supply Hall',
    查看更多: 'View More',
    采购大厅: 'Procurement Hall',
    截止日期: 'Deadline',
    交货期限: 'Delivery Deadline',
    数量: 'Quantity',
    去询价: 'Inquire',
    平台介绍: 'Platform Introduction',
    新闻动态: 'News and Updates',
    产品名称: 'Product Name',
    产品描述: 'Product Description',
    供应商: 'Supplier',
    月供应量: 'Monthly Supply',
    物流方式: 'Logistics Mode',
    询价: 'Inquire',
    平台介绍详情:
      "Build 'One Standard, Two Ecosystems, Three Assets', focusing on the import and export trade of aviation industrial products. Relying on the Zhuhai Airshow, extend the business to make the airshow trade normalized, digitalized, and internationalized. The goal is to become a world - class comprehensive service platform for aviation industrial commerce.",
    琴航航空工业品平台: 'Industrial Products Platform',
    推荐品牌: 'Recommended brand',
	推荐:'recommend',
    全球工业化智能解决方案: 'Global Industrial Intelligent Solutions',
    二手飞机推荐: 'Used Aircraft Recommendations',
    供求大厅: 'Supply and Demand Hall',
    更多供求: 'More supply and demand',
	    "全面定制化供应链服务": "Customized supply chain services",
	"立即体验AI助手": "Try AI Assistant Now",
    "AI助手": "AI Assistant"
  },
  aiObject: {
    "title": "AI Intelligent Assistant",
    "connected": "Connected",
    "placeholder": "Please enter your question",
    "send": "Send",
    "stop": "Stop Generation",
    "clear": "Clear Records",
    "welcome": "Hello! I'm an AI intelligent assistant. How can I help you?",
    "thinking": "Thinking...",
    "error": "Sorry, I cannot answer your question at the moment. Please try again later.",
    "networkError": "Sorry, there was a network connection issue. Please try again later.",
    "stopped": "Generation stopped",
    "confirmClose": "The AI assistant is generating content. Are you sure you want to close it?",
    "notice": "Notice",
    "confirm": "Confirm",
    "cancel": "Cancel"
  },
  PageHeader: {
    首页: 'Home',
    供应大厅: 'Supply Hall',
    采购大厅: 'Procurement Hall',
    二手飞机库: 'used aircraft',
    备件商城: 'Spare Parts Mall',
    招采平台: 'Procurement platform',
    解决方案: 'Solutions',
    新闻中心: 'News Center',
    关于我们: 'About Us',
    简体中文: '简体中文',
    '登录/注册': 'Login/Register',
    欢迎您走进琴航科技: 'Welcome to Kinghang Technology',
	"已退出登录":'Logged out'
  },
  reservation: {
    "预约": "Reservation",
    
    // 头部横幅文本
    "title1": "Meet Connect Tech At IDEF",
    "title2": "2025",
    "title3": "All Actors of the Defence Industry Under One Roof",
    "title4": "22-27 July 2025 - Stand 8-C14A",
    
    // 内容描述段落
    "desc1": "IDEF 2025 17th International Defence Industry Fair will be hosted by the Republic of Türkiye Ministry of National Defence, supported by the Presidency of the Republic of Türkiye Secretariat of Defence Industries, under the management and responsibility of Turkish Armed Forces Foundation and organized by KFA Fairs Organization Inc. between 22-27 July 2025 at the Istanbul Expo Center.",
    "desc2": "Join Connect Tech and partner",
    "desc2_link": "Bernier",
    "desc2_cont": "at Stand 8-C14A. As an NVIDIA Elite Partner, Connect Tech products include small, low power, ruggedized solutions for crewed and uncrewed applications. These compact and powerful edge devices can be easily carried or deployed onto a range of vehicles providing real-time decision making at the tactical edge.",
    "desc3": "Book a meeting now to discuss your application in detail and learn about potential solutions for your specific design requirements.",
    "desc4": "Please fill out the form to schedule your meeting.",
    "required_note": "mandatory fields",
    
    // 表单标签
    "label_salutation": "Salutation:",
    "label_first_name": "First Name:",
    "label_last_name": "Last Name:",
    "label_email": "Email:",
    "label_job_title": "Job Title:",
    "label_company": "Company:",
    "label_phone": "Phone:",
    "label_country": "Country:",
    "label_message": "Message:",
    
    // 占位符文本
    "ph_choose": "—Please choose an option—",
    "ph_first_name": "Please enter your first name",
    "ph_last_name": "Please enter your last name",
    "ph_email": "Please enter your email",
    "ph_job_title": "Please enter your job title",
    "ph_company": "Please enter your company",
    "ph_phone": "Please enter your phone number",
    "ph_country": "Please enter your country",
    "ph_message": "Please enter your message or specific requirements",
    
    // 按钮和状态文本
    "btn_submit": "Submit",
    "btn_submitting": "Submitting...",
    "msg_success": "Reservation submitted successfully! We will contact you soon.",
    "msg_validation": "Please fill in all required fields correctly",
    "msg_error": "Failed to submit reservation. Please try again."
  },
  CommonFooter: {
    '琴航（广东横琴）科技有限公司': 'KingHang Technology Co., Ltd. (Guangdong Hengqin, China)',
    '400-000-0000': '400-000-0000',
    '地址：珠海市香洲区厚朴道398号横琴国际科技创新中心 7栋708-2':
      'Address: 5th Floor, Unit 2, No. 2515, Huandao North Road, Hengqin District, Zhuhai',
    'contactEmail': 'Mail: Kinghang@e99.cn',
    关于我们: 'About Us',
    供应大厅: 'Supply Hall',
    需求大厅: 'Demand Hall',
    解决方案: 'Solutions',
    增值服务: 'Value-added Services',
    服务: 'Services',
    帮助中心: 'Help Center',
    安全保障: 'Security Assurance',
    联系我们: 'Contact Us',
    '© 2025 琴航（广东横琴）科技有限公司   版权所有  粤ICP备2025393208号-1':
      '© 2025 KinG hang (Guangdong Hengqin) Technology Co., Ltd. All rights reserved. Guangdong ICP No. 2025393208-1',
    热门产品分类: 'Popular Product Categories',
    智能无人机制造: 'Intelligent Drone Manufacturing',
    无人机: 'Drones',
    螺旋桨: 'Propellers',
    RC电子配件: 'RC Electronic Components',
    起落架和收起: 'Landing Gear and Retraction',
    碳纤维材料: 'Carbon Fiber Materials',
    无人机遥控器: 'Drone Remote Controllers',
    帮助与支持: 'Help & Support',
    关于琴航: 'About KingHang',
    了解琴航: 'About Us',
	
	
    加入琴航: 'Join KingHang',
	可持续发展: 'Sustainable Development',
	廉洁举报: 'Integrity Reporting',
	行业动态: 'Industry Updates',
	最新科技: 'Latest Technology',
	平台规则: 'Platform Rules',
	常见问题: 'Frequently Asked Questions',
	安全保障: 'Security Assurance',
	
	
    投资者关系: 'Investor Relations',
    新闻动态: 'News',
    琴航资讯: 'KingHang News',
    'Copyright © 2025 琴航（广东横琴）科技有限公司': 'Copyright © 2025 KingHang Technology Co., Ltd. (Guangdong Hengqin)',
	"版权所有": "All Rights Reserved",
	"使用条款": "Terms of Service",
	"粤ICP备2025393208号-1": "Guangdong ICP No. 2025393208-1",
	"网站地图": "Site Map",
	
	"元器件": "component",
	"应急装备": "emergency equipment",
	"光学传感器": "optical sensor",
	"mems": "mems",
	"复合材料": "composite material",
	"低空飞行器": "aircraft",
	"其他": "other",
  },
  'product-list': {
    条件查询: 'Conditional Query',
    设备分类: 'Device Category',
    运输方式: 'Transportation Method',
    产品标签: 'product labeling',
    供应商类型: 'Supplier Type',
    商品名称: 'Product Name',
    全部: 'All',
    供应商店铺: 'Supplier Store',
    自营店铺: 'Self-operated Store',
    请输入商品名称: 'Please enter the product name',
    搜索: 'Search',
    重置: 'Reset',
    '共 {count} 个结果': 'Total {count} results',
    发布时间: 'Release Time',
    查看次数: 'View Count',
    取消收藏: 'Cancel Collection',
    收藏: 'Collect',
    询价: 'Inquire',
    人工询价: 'Human Inquiry',
    智能询价: 'AI Inquiry',
    暂无产品: 'No products available',
    解决方案应用: 'Solution application',
    您想要的产品: 'The product you want',
  },
  'product-details': {
    供应大厅: 'Supply Hall',
    产品详情: 'Product Details',
    取消收藏: 'Cancel Collection',
    加入收藏: 'Add to Favorites',
    收藏: 'Collect',
    加入询盘: 'Join Inquiry',
    取消询盘: 'Cancel inquiry',
    '1V1专家咨询': '1V1 Expert Consultation',
    商品详情: 'Product Details',
    用户案例: 'User Cases',
    服务支持: 'Service Support',
    专家咨询: 'Expert Consultation',
    '请留下您的联系方式，方便我们与您联系': 'Please leave your contact information for us to contact you.',
    也可直接联系客服邮箱: 'You can also directly contact the customer service email',
    请输入您的联系方式: 'Please enter your contact information',
    '取 消': 'Cancel',
    '确 定': 'OK',
    提交成功: 'Submission successful',
    联系我们: 'Contact Us',
    规格: 'Specifications',
    价格: 'Price',
    月供应量: 'Monthly Supply',
    运输方式: 'Transportation Method',
	
	"规格详情": "Specification details",
	"描述": "describe",
  },
  'purchase-list': {
    条件查询: 'Conditional Query',
    设备分类: 'Device Category',
    '共 {count} 个设备': 'Total {count} devices',
    发布时间: 'Release Time',
    查看次数: 'View Count',
    去咨询: 'Consultation',
    暂无产品: 'No products available',
    截止日期: 'Deadline',
    数量: 'Quantity',
  },
  'purchase-details': {
    采购大厅: 'Purchase Hall',
    需求详情: 'Demand Details',
    进行中: 'In Progress',
    采购数量: 'Purchase Quantity',
    预算金额: 'Budgeted Amount',
    交货期限: 'Delivery Date',
    距离截止还剩: 'Time Remaining Until Deadline',
    采购需求详情: 'Purchase Demand Details',
    采购商详情: 'Purchaser Details',
    已认证: 'Certified',
    成立时间: 'Establishment Time',
    员工: 'Employees',
    相关推荐: 'Related Recommendations',
    截止时间: 'Deadline',
    采购中: 'Purchasing',
    数量: 'Quantity',
    已截止: 'Closed',
    天: 'days',
  },
  solution:{
    安防光电类供应链:'Security Optoelectronic Supply Chain',
    安防光电类供应链介绍:'安防光电类供应链',
    应急救援解决方案:'Emergency Rescue Solution',
    应急救援解决方案介绍:'This solution is built upon the core product technologies of the platform\'s fire emergency rescue system, and is based on the Firefighter Individual Protection System as the foundational supporting module. It addresses diverse scenario-based emergency rescue requirements, delivering efficient, modularized, and intelligent equipment combinations along with full-process service support.',
    noticeTitle:'Drone Supply Chain Solution',
    description:'Whether it\'s individual needs such as fuselage and power systems, or complete aircraft requirements, we can meet customer needs with efficient and high-quality service.',
    返回上页:'Back',
	'单项需求策略':'Individual Demand Strategy',
    整机需求策略:'Complete Aircraft Requirements Strategy',
    服务流程:'Service Process',
    质量保障与售后服务:'Quality Assurance and After-sales Service',
    相关产品:'Related Products',
    产品详情:'Product Details',
    了解更多产品:'Learn More Products',
    更多产品:'More Products',
    规格:'Specifications',
    深入了解:'Deep Learn',
    相关解决方案:'Related Solutions',
    查看详情:'View Details',
    您当前位置:'Your Position',
'您当前位置：首页': 'Your current location: Home',
    应用场景及解决方案:'Application Scenarios and Solutions',
    核心优势:'Core Advantages',
    '核心优势描述':'The plan integrates intelligent equipment, suitable for advanced equipment such as hydraulic fracturing, underwater rescue, intelligent robots, personal protection, etc., combined with standardized operating procedures and technical support, to build an emergency rescue closed-loop system covering "monitoring and early warning - rapid response - precise disposal - safety guarantee - continuous optimization", suitable for urban rescue, earthquake disasters, water search and rescue, hazardous chemical accidents and other scenarios, achieving dual improvement of rescue efficiency and safety, and minimizing casualties and property losses.',
    '基础模块：消防单兵守护系统':'Firefighter Individual Protection System',
    '消防单兵守护系统定位':'Positioning of the fire individual protection system',
    '消防单兵守护系统定位描述':'The fire individual protection system is the core security guarantee for emergency rescue. Through integrated positioning, monitoring, and communication functions, it provides real-time life safety protection for rescue personnel and precise data support for the command center.',
    '功能模块与产品组成':'Function Modules and Product Composition',
    '功能模块':'Function Modules',
    '对应产品/技术':'Corresponding Products/Technologies',
    '技术参数与用途':'Technical Parameters and Usage',
    '系统优势':'System Advantages',
    '应用场景':'Application Scenarios',
    // solutionList 相关翻译
    机身: 'Fuselage',
    机身描述: 'Collaborate with renowned fuselage manufacturers to provide various<br>material options (e.g. carbon fiber, aluminum alloy) and structural<br>design choices to meet different performance and application requirements.<br>Customers can choose based on their specific needs for weight, strength, and corrosion resistance.',
    动力系统: 'Power System',
    动力系统描述: 'Integrate premium battery, motor, ESC and propeller suppliers to offer<br>comprehensive power solutions for various drone applications.',
    飞控系统: 'Flight Control System',
    飞控系统描述: 'Partner with advanced flight control R&D companies to provide<br>powerful and reliable flight control products. Features multiple<br>flight modes, high-precision sensor fusion technology and<br>intelligent obstacle avoidance. Customizable algorithms and<br>functions based on stability, maneuverability and autonomy needs.',
    传感器: 'Sensors',
    传感器描述: 'Collaborate with leading sensor manufacturers to provide high-precision<br>sensors including GPS, gyroscopes, accelerometers, and barometers.<br>Offer precise selection and configuration based on application scenarios<br>and performance requirements. Ensure stability for altitude and flow<br>sensors in mapping drones through GPS grid optimization.',
    通信系统: 'Communication System',
    通信系统描述: 'Collaborate with professional communication equipment suppliers to<br>provide systems with different frequency bands, transmission distances<br>and anti-interference capabilities. Ensure stable data and video<br>transmission between drones and ground stations using data radios and<br>video transmitters. Customizable for transmission range, data rate<br>and security requirements.',
    任务载荷: 'Mission Payloads',
    任务载荷描述: 'Connect with multiple payload manufacturers to offer diverse options:<br>HD cameras for aerial photography, multispectral cameras for agriculture<br>monitoring, thermal imagers for security inspections. Provide customized<br>payload solutions and integration services based on industry-specific<br>application requirements.',
    // part21.vue solutionList 相关翻译
    摄像头模组: 'Camera Module',
    摄像头模组描述: 'Collaborate with global leading optical manufacturers to offer high-definition (4K/8K), low-light, wide dynamic range (WDR) cameras with various options such as focal length, aperture, and resolution. Customize parameters to adapt to indoor/outdoor lighting conditions and integrate AI chips for face recognition, behavior analysis, etc.',
    红外热成像设备: 'Infrared Thermography Device',
    红外热成像设备描述: 'Partner with infrared detector manufacturers to offer non-cooling and cooling<br>thermography modules with resolutions ranging from 160x120 to 1280x1024. The temperature accuracy is ±1℃. The modules support 24-hour monitoring and are suitable for perimeter protection, fire warning, etc. Customizable temperature ranges and image enhancement algorithms are available.',
    智能分析系统: 'Intelligent Analysis System',
    智能分析系统描述: 'Integrate AI algorithm resources to offer video structured analysis, multi-object tracking, and anomaly behavior detection software solutions. The cameras can be integrated with the edge computing and cloud collaboration capabilities. Customize algorithm models (e.g. license plate recognition, crowd density analysis) based on customer requirements.',
    存储与传输设备: 'Storage & Transfer Device',
    存储与传输设备描述: 'Partner with storage device manufacturers to offer high-performance NVRs (network video recorders), distributed storage servers, and cloud storage solutions. Customize algorithm models (e.g. license plate recognition, crowd density analysis) based on customer requirements.',
    辅助设备: 'Assistive Device',
    辅助设备描述: 'Offer bracket, protective shield, and flashlight accessories to adapt extreme environments (e.g. high temperatures, heavy rain, underwater, and antibacterial). Extend the lifespan of devices.',
    // part14.vue solutionList 相关翻译
    城市建筑坍塌救援: 'Urban Building Collapse Rescue',
    城市建筑坍塌救援描述: 'Pain Points: Low efficiency in concrete structure demolition, high risk of secondary collapse, difficulty in narrow space rescue.',
    地震灾害救援: 'Earthquake Disaster Rescue',
    地震灾害救援描述: 'Pain Points: Complex ruins environment, difficult transportation of heavy equipment, high aftershock risk.',
    水域救援: 'Water Rescue (Flood/Shipwreck Accidents)',
    水域救援描述: 'Pain Points: Low underwater visibility, difficult obstacle cutting, insufficient rescue response speed.',
    危化品泄露与火灾: 'Hazardous Chemical Leakage and Fire',
    危化品泄露与火灾描述: 'Pain Points: High explosion risk, rapid toxic gas diffusion, low traditional firefighting efficiency.',
    // part4.vue strategyList 相关翻译
    需求沟通与方案定制: 'Requirement Communication & Customization',
    需求沟通与方案定制描述: 'Gain in-depth understanding of customer requirements including usage scenarios (aerial photography, logistics, surveying etc.), performance needs (endurance, payload, accuracy), budget constraints and special functional requirements to develop detailed, customized drone solutions.',
    整合优质资源生产组装: 'Premium Resource Integration & Assembly',
    整合优质资源生产组装描述: 'Procure high-quality components from suppliers with strict quality control. Perform precision assembly according to industry standards and customer requirements to ensure optimal drone performance.',
    全面测试与质量检测: 'Comprehensive Testing & Quality Inspection',
    全面测试与质量检测描述: 'Conduct extensive testing including flight performance, reliability and environmental adaptability. Perform rigorous quality inspections per international standards to ensure 100% compliance before delivery.',
    售后服务与技术支持: 'After-sales Service & Technical Support',
    售后服务与技术支持描述: 'Provide comprehensive after-sales services including maintenance, parts replacement, software upgrades and technical consulting. Establish rapid response mechanisms to resolve issues promptly.',
    // part6.vue serviceFlowItems 相关翻译
    需求收集与分析: 'Requirement Collection & Analysis',
    需求收集与分析描述: 'Gather detailed customer requirements through online/offline communication and form requirement analysis reports.',
    方案设计与报价: 'Solution Design & Quotation',
    方案设计与报价描述: 'Design targeted solutions and provide detailed quotations including product specifications, pricing and delivery timelines.',
    合同签订与订单确认: 'Contract Signing & Order Confirmation',
    合同签订与订单确认描述: 'Finalize contracts clarifying rights/obligations and confirm order details through commercial negotiations.',
    采购与生产安排: 'Procurement & Production Planning',
    采购与生产安排描述: 'Procure components from suppliers, coordinate production schedules and ensure manufacturing quality control.',
    质量检测与测试: 'Quality Inspection & Testing',
    质量检测与测试描述: 'Conduct multiple rounds of quality checks on components and flight tests on complete drones to ensure compliance.',
    包装运输与交付: 'Packaging & Logistics',
    包装运输与交付描述: 'Use professional packaging and optimal transportation methods to ensure safe and timely delivery.',
    售后服务: 'After-sales Support',
    售后服务描述: 'Provide post-sale support with regular follow-ups, collect feedback and continuously improve services.',
    // part6.vue qualityServiceItems 相关翻译
    质量保障体系: 'Quality Assurance System',
    质量保障体系描述: 'Establish a rigorous quality control system that complies with international standards and industry regulations across all stages: supplier selection, raw material procurement, production, inspection, and packaging.',
    售后服务团队: 'After-sales Service Team',
    售后服务团队描述: 'Professional team providing 24/7 support through phone, email and remote assistance to resolve customer issues promptly.',
    售后内容: 'Service Coverage',
    售后内容描述: 'Offer warranty services with free repairs/replacements during coverage period. Provide operational training and technical guidance. Maintain spare parts inventory for timely supply.',
    // part22.vue strategyList 相关翻译
    需求沟通与方案定制2: 'Requirement Communication & Customization',
    需求沟通与方案定制描述2: 'Deeply understand customer scenarios (e.g., campus security, traffic hub monitoring, industrial coverage) to develop a complete drone solution.',
    资源整合与系统集成: 'Resource Integration & System Integration',
    资源整合与系统集成描述: 'From core components (cameras, infrared modules) to peripheral devices (storage, power), carefully select suppliers and ensure compatibility with products. Complete hardware assembly and software debugging to ensure seamless co-operation among devices.',
    联调测试与场景验证: 'Coordination Testing & Scenario Validation',
    联调测试与场景验证描述: 'Simulate real scenarios for stress testing: including image clarity, night vision, network delay, AI analysis accuracy, etc. Optimize system stability and response speed.',
    安装部署与运维支持: 'Installation & Deployment Support',
    安装部署与运维支持描述: 'Provide on-site installation guidance or remote technical support to assist customers in completing system deployment. Establish operation and maintenance response mechanism, regularly remote diagnosis of equipment status, prevent potential failures.',

    // part12.vue features
    '技术领先性': 'Technological Leadership',
    '技术领先性副标题': 'Technological leadership',
    '技术领先性描述': 'Lightweight design, modular combination, intelligent control technology (such as beidou positioning, heat imaging monitoring).',
    '场景全覆盖': 'Full Scene Coverage',
    '场景全覆盖副标题': 'Full scene coverage',
    '场景全覆盖描述': 'From city collapse to water rescue, from chemical leakage to forest fire, all provide specific equipment combinations.',
    '安全双保险': 'Double Safety Insurance',
    '安全双保险副标题': 'Double safety insurance',
    '安全双保险描述': 'Equipment antibombardment design + single-man life monitoring system, double-safety to ensure the safety of rescue personnel.',
    '服务全周期': 'Service Full Cycle',
    '服务全周期副标题': 'Full service cycle',
    '服务全周期描述': 'Provide from device configuration, operation training, to after-sales maintenance, one-stop support.',
    '实时定位与导航': 'Real-time Location and Navigation',
    '北斗三号融合终端': 'Beidou 3 Integrated Terminal',
    '定位误差参数': 'Horizontal error ≤3m, vertical error <0.5m, no signal area supports short message communication.',
    '生命体征监测': 'Life Signs Monitoring',
    '单兵生命体征传感器': 'Single-man Life Signs Sensor (Integrated into Protection Suit)',
    '生命体征参数': 'Real-time monitoring of heart rate, temperature, and blood oxygen saturation, and automatic alarm for abnormal values.',
    '环境风险感知': 'Environment Risk Perception',
    '手持式长波红外成像气体检测仪': 'Handheld Long-Wave Infrared Imaging Gas Detector',
    '气体检测参数': 'Detects 16 types of harmful gases (CO, H2S, etc.), with accuracy ±1ppm.',
    '氧气余量监控': 'Oxygen Remaining Monitoring',
    '智能氧气瓶压力传感器': 'Intelligent Oxygen Bottle Pressure Sensor',
    '氧气监控参数': 'Displays remaining oxygen time in real time, low pressure warning (threshold ≤5MPa).',
    '通讯与数据回传': 'Communication and Data Return',
    '卫星电话融合终端': 'Satellite Phone Integrated Terminal',
    '通讯参数': 'Supports voice calls and hot-imaging video transmission to the command center.',
    '多维度安全防护': 'Multi-dimensional Protection',
    '多维度安全防护描述': 'From physiological status to environmental risks, full-coverage monitoring warning.',
    '轻量化集成设计': 'Lightweight Integrated Design',
    '轻量化集成设计描述': 'Total weight <2kg, does not affect rescue personnel mobility.',
    '智能决策支持': 'Intelligent Decision Support',
    '智能决策支持描述': 'AI algorithm automatically analyzes data and pushes evacuation paths and first aid suggestions.',
    '高层火灾': 'High-level Fire',
    '高层火灾描述': 'By beidou positioning floor location, oxygen remaining warning prevents suffocation risk.',
    '化工爆炸': 'Chemical Explosion',
    '化工爆炸描述': 'Gas detector real-time alarm, remote dispatch evacuation route from the command center.',
    '地下隧道': 'Underground Tunnel',
    '地下隧道描述': 'Short message function ensures communication and positioning without GPS signal.',
  },
  'solution-details': {
    解决方案标题: 'Solution',
    方案详情: 'Solution Details',
    文章标题: 'Article Title',
    文章描述: 'Article Description',
    一站式数据资产管理: 'One-stop Data Asset Management',
    业务挑战: 'Business Challenges',
    解决方案: 'Solutions',
    方案价值: 'Solution Value',
    '1V1专家咨询': '1-on-1 Expert Consultation',
    '端到端解决方案，加速释放数据价值': 'End-to-end Solution to Accelerate Data Value Release',
    数据平台: 'Data Platform',
    数据管理平台: 'Data Management Platform',
    数据仓库: 'Data Warehouse',
    咨询流程: 'Consultation Process',
    需求咨询: 'Requirement Consultation',
    初步沟通: 'Initial Communication',
    方案交流: 'Solution Exchange',
    商务流程: 'Business Process',
    '提交相关需求，描述业务背景': 'Submit relevant requirements and describe the business background',
    '需求确认，对平台心疑惑，解决合作顾虑':
      'Confirm requirements, address doubts about the platform, and resolve cooperation concerns',
    针对相关方案进行详述并就技术问题深讨: 'Detail relevant solutions and discuss technical issues',
    '方案确定后，开始执行商务流程': 'After the solution is confirmed, start the business process',
    暂无数据: 'No data available at the moment',
  },
  // 新增 news-list 对象
  'news-list': {
    新闻中心: 'News Center',
    '中国智造 走向世界': 'Made in China, Going Global',
    点击查看更多: 'Click to view more',
  },
  'news-details': {
    新闻中心: 'News Center',
    新闻详情: 'News Details',
    发布日期: 'Release Date',
	'平台信息': 'Platform Information'
  },
  'contact-us': {
    '标题': 'Contact Us',
    '展会介绍': 'KingHang (Guangdong Hengqin) Technology Co., Ltd., as a leading enterprise in the aerospace industrial cross-border one-stop service platform, is always committed to providing efficient and professional industrial solutions to global customers. With our deep industry experience and innovative service model, we have successfully built a bridge connecting international suppliers and demanders, facilitating the efficient development of the global aerospace industry. In international markets such as Istanbul, Turkey, KingHang Technology has established an extensive cooperation network, providing customers with full-service from supply chain management to technical support through localized service teams and digital platforms. Our services cover aerospace components, equipment and technical solutions, ensuring that every link meets the highest international standards. In the future, KingHang Technology will continue to deepen its global layout, expand emerging markets, and inject new momentum into the development of the global aerospace industry. We look forward to working hand in hand with more partners to create brilliance and promote industry progress.',
    '电话': 'Phone',
    '邮箱': 'Mail：Kinghang@e99.cn',
    '图片描述': 'Contact Us - KingHang Technology Participating in IDEF Defense Industry Exhibition'
  },
  about: {
    关于我们: 'About Us',
    更新时间: 'Update Time: ',
	'新闻详情': 'News Details',
	'了解琴航': 'About Kinghang',
	'琴航文化': 'Corporate Culture',
	'核心优势': 'Core Advantages',
	'股东背景': 'Shareholder Background',
	'政策支持': 'Policy Support',
	'展望未来': 'Future Outlook',
	'您当前的位置：首页': 'Current Location: Home',
	'用户昵称':'userName',
    	// 模块1
      '成立背景': 'Establishment Background',
      'txt1': 'As a strategic emerging industry, the low-altitude economy has enormous potential. The government is actively promoting its development. In recent years, the aerospace industrial products sector has grown rapidly, giving rise to many advanced tech companies and forming a complete industrial chain. However, cross-border sales of aerospace industrial products are still in their infancy.',

      '公司简介': 'Company Profile',
      'txt2': 'King hang Technology is China\'s first one-stop cross-border service platform specializing in aerospace industrial products. Established in December 2024, we aim to implement the national "dual-circulation" strategy and address the industry\'s lack of experience in international trade.',

      '股东结构': 'Shareholder Structure',
      'txt3': 'Kinghang\'s shareholder structure is led by a Zhuhai state-owned assets consortium including Dahengqin Group, Zhuhai Low-altitude Industry Investment & Operation Company, and Zhuhai Convention & Exhibition Group. The National Federation of Industry & Commerce\'s Technology Equipment Chamber also participates to enhance resource integration capabilities.',

      '团队力量': 'Team Strength',
      'txt4': 'Our core team members come from leading organizations including China Aerospace Science and Technology Corporation, Poly Defense, military institutions, and Langhua Group. With over a decade of experience in domestic industrial products, we possess rich resources across supply chain management, compliance, financial services, and logistics.',

    	// 模块2
      '战略定位': 'Strategic Positioning',
      'txt5': 'Guided by the "One-Two-Three" development model, we aim to build "One Standard, Two Ecosystems, Three Assets" with high quality. This includes establishing industry standards, cultivating digital and industrial ecosystems, and developing three core assets (data, technology, and brand). Our mission is to promote the internationalization of China\'s aviation industry standards and position Zhuhai as a core city in the aviation industry chain.',

      '发展目标': 'Development Objectives',
      'txt6': 'Focusing on import/export of aerospace industrial products, we are committed to building normalized, digitalized and internationalized trade operations with a robust data management system. By integrating online and offline services, and leveraging accumulated trade data to unlock industry potential, we aim to enhance China\'s aviation capabilities, promote standard development, and establish ourselves as a world-leading cross-border trade platform that drives aerospace industry cluster development in the Greater Bay Area.',

      // 模块3
      // 模块3翻译
      'txt7': 'King hang\'s cross-border trade services cover the entire process of aerospace industrial product import/export (customs clearance, logistics, financing, compliance, etc.). Through data-driven approaches, we leverage trade data accumulation to unlock industry potential and empower industrial chain upgrades.',

      '技术亮点': 'Technical Highlights',
      'txt8': 'Our digital platform integrates airshow resources to achieve online-offline collaborative services. We benchmark international standards to promote certification and global adoption of China\'s aviation technologies.',

      '差异化优势': 'Differentiated Advantages',
      'txt9': 'Our state-backed ownership ensures resource stability, while full industrial chain services lower the cross-border threshold for enterprises.',

      '海外资源优势': 'Overseas Resource Advantages',
      'txt10': 'Our core team possesses extensive international collaboration experience. Leveraging the National Federation of Industry & Commerce\'s Technology Equipment Chamber, we provide global supply chain integration and market expansion services. As a cross-border platform, we offer greater flexibility in personnel mobility management compared to state-owned enterprises in sensitive industries.',

      '股东资源': 'Shareholder Resources',
      'txt11': 'Qinhuangdao Zhuhai State owned Assets is an important part of the group s strategic layout in the aerospace industry chain; At the same time, relying on the resources of China Airshow, we will strengthen our brand and channel advantages.',

    	// 模块4
      '横琴战略地位': 'Hengqin Strategic Position',
      'txt12': 'Located at the core of the Guangdong-Hong Kong-Macao Deep Cooperation Zone, Kinghang Technology benefits from cross-border financial and tax policy advantages. Adjacent to Macau, we serve as a "super gateway" connecting international markets.',
      '政策赋能': 'Policy Empowerment',
      'txt13': 'Kinghang Technology is included in the "Hengqin Overall Development Plan" to support high-end manufacturing and cross-border service innovation. Zhuhai is building an aviation industry cluster, with Kinghang as its core platform.',

    	// 模块5
      '短期规划': 'Short-term Plan',
      'txt14': 'Kinghang Technology will enhance platform functionalities and expand cross-border service coverage in fields like low-altitude economy and drone industry chain.',
      '长期愿景': 'Long-term Vision',
      'txt15': 'Become a global trade hub for aerospace industrial products, promoting Chinese standards and technology exports. Support the development of Hengqin as a "Smart Island" exploring blockchain and AI applications in cross-border trade.',
      'txt16': 'Looking ahead, Dahengqin Group will actively implement national and provincial strategies for low-altitude economy development. Leveraging Zhuhai\'s policy advantages and the geographical strengths of the Guangdong-Macao In-Depth Cooperation Zone, we will fully support Kinghang Technology\'s growth to drive aerospace industrial chain development and contribute to China\'s aviation industry advancement.',

      // 底部栏
      'hotProducts': 'Popular Categories',
      'productCategories': `Intelligent UAV Manufacturing<br>
                           Drones<br>
                           Propellers<br>
                           RC Electronic Components`,

      'helpSupport': 'Help & Support',
      'platformRules': 'Platform Rules',
      'commonQuestions': 'FAQ',
      'securityGuarantee': 'Security',
      'contactUs': 'Contact Us',

      'aboutQinhang': 'About Us',
      'aboutUs': 'Understand Kinghang',
      'joinUs': 'Careers',
      'investorRelations': 'Investor Relations',
      'sustainability': 'Sustainability',
      'reportMisconduct': 'Ethics Reporting',

      'newsUpdates': 'News & Updates',
      'companyNews': 'Company News',
      'industryTrends': 'Industry Trends',
      'latestTech': 'Technology Updates',

      'companyAddress': 'Address: Room 708-2, Building 7, Hengqin International Sci-Tech Innovation Center, Houpu Road, Xiangzhou District, Zhuhai',

      'copyright': `Copyright&nbsp;©&nbsp;2025&nbsp;Kinghang (Guangdong Hengqin) Technology Co., Ltd&nbsp;All Rights Reserved&nbsp;&nbsp;|&nbsp;&nbsp;Privacy Policy&nbsp;&nbsp;|&nbsp;&nbsp;Terms of Use&nbsp;&nbsp;|&nbsp;&nbsp;粤ICP备2025393208号-1&nbsp;&nbsp;|&nbsp;&nbsp;Sitemap`
  },
  'collect-list': {
    我的收藏: 'My Collection',
    返回个人中心: 'Back to Personal Center',
    取消收藏: 'Cancel Collection',
    暂无产品: 'No products available',
  },
  'shop-list': {
    未提交购物车: 'Unsubmitted shopping cart',
    返回个人中心: 'Back to Personal Center',
    取消: 'Cancel',
    暂无产品: 'No products available',
    提交: 'Submit',
  },
  'submit-list': {
    购物车提交记录: 'Shopping cart submission record',
    返回个人中心: 'Back to Personal Center',
    暂无提交记录: 'No submission records available at the moment',
  },
  'submit-detail': {
    购物车提交记录详情: 'Shopping Cart Submission Record Details',
    返回购物车提交记录页: 'Return to the shopping cart submission record page',
  },
  Card1: {
    个人中心: 'Personal Center',
    供应商: 'Supplier',
    采购商: 'Purchaser',
    已完成企业认证: 'Enterprise certification completed',
    未完成企业认证: 'Enterprise certification not completed',
    认证审核中: 'Certification under review',
    '审核未通过,请重新认证': 'Review failed, please re - certify',
    编辑资料: 'Edit Profile',
    认证信息: 'Authentication Info',
    退出登录: 'Log Out',
    '是否确认退出?': 'Are you sure you want to log out?',
    提示: 'Prompt',
    确定: 'Confirm',
    取消: 'Cancel',
    '确定要退出登录吗？': 'Are you sure you want to log out?',
	'是否翻译':'Whether to translate Chinese product information？',
	'翻译产品':'Translation products'
  },
  Card2: {
    本月订单总额: 'Total order amount this month',
    较上月增长: 'Increase compared to last month',
    较上月降低: 'Decrease compared to last month',
    较上月无变化: 'No change compared to last month',
  },
  Card3: {
    待处理订单: 'Pending Orders',
    查看详情: 'View Details',
  },
  Card4: {
    退货订单: 'Return Orders',
    查看详情: 'View Details',
  },
  Card5: {
    我的订单: 'My Orders',
    查看全部: 'View All',
    待付款: 'Pending Payment',
    待发货: 'Pending Shipment',
    待收货: 'Awaiting Receipt',
    收货完成: 'Received',
    退换货: 'Returns & Exchanges',
  },
  Card6: {
    采购需求: 'Purchase Requirements',
    需求管理: 'Demand Management',
    有效采购需求: 'Valid Purchase Requirements',
    待审核需求: 'Pending Review Requirements',
  },
  Card7: {
    账户安全: 'Account Security',
    安全等级: 'Security Level',
    企业认证: 'Enterprise Certification',
    已认证: 'Certified',
    未完成企业认证: 'Enterprise Certification Incomplete',
    '审核未通过,请重新认证': 'Verification Failed, Please Reapply',
    认证审核中: 'Certification Under Review',
    高: 'Above The Average',
  },
  Card8: {
    收藏夹: 'Favorites',
    查看全部: 'View All',
    暂无收藏产品: 'No favorite products available',
  },
  Card9: {
    消息中心: 'Message Center',
    查看全部: 'View All',
    订单发货通知: 'Order Shipment Notification',
    '您的订单 {orderId} 已发货': 'Your order {orderId} has been shipped',
    '{time} 前': '{time} ago',
  },
  Card10: {
    我的产品: 'My Products',
    新增产品: 'Add New Product',
    全部: 'All',
    已上架: 'Published',
    未上架: 'Unpublished',
    审核中: 'Under Review',
    审核通过: 'Approved',
    审核失败: 'Rejected',
    提交审核: 'Submit for Review',
    下架: 'Take Off Shelf',
    上架: 'Putaway',
    编辑: 'Edit',
    删除: 'Delete',
    暂无产品: 'No products available',
    上传图片: 'Upload Pictures',
    导入产品: 'Import Product',
  },
  Card11: {
    我的产品: 'My Products',
    新增需求: 'Add New Requirement',
    返回个人中心: 'Back to Personal Center',
    全部: 'All',
    审核中: 'Under Review',
    审核通过: 'Approved',
    审核失败: 'Rejected',
    提交审核: 'Submit for Review',
    编辑: 'Edit',
    删除: 'Delete',
    暂无需求: 'No requirements available',
    已通过: 'Passed',
    审核中1: 'Under review',
    未通过: 'Failed',
    未审核: 'Not reviewed',
  },
  Card12: {
    我的订单: 'My Orders',
    返回个人中心: 'Back to Personal Center',
    所有订单: 'All Orders',
    待付款: 'Pending Payment',
    待发货: 'Pending Shipment',
    已发货: 'Shipped',
    收货完成: 'Completed',
    退换货: 'Return/Exchange',
    暂无需求: 'No demands available',
    提交审核: 'Submit for Review',
    编辑: 'Edit',
    删除: 'Delete',
    退款: 'Refund',
  },
  Card13: {
    未提交购物车: 'Unsubmitted shopping cart',
    查看全部: 'View All',
    暂无产品: 'No products',
  },
  Card14: {
    购物车提交记录: 'Shopping cart submission record',
    查看全部: 'View All',
    暂无提交记录: 'No submission records available at the moment',
  },
  userEdit: {
    修改个人信息: 'Edit Personal Information',
    头像: 'Avatar',
    用户名称: 'User Name',
    同步登录账号: 'Sync Login Account',
    手机号: 'Phone Number',
    邮箱: 'Email',
    请输入: 'Please enter',
    请输入正确的手机号: 'Please enter a valid phone number',
    请输入正确的邮箱: 'Please enter a valid email',
    '提 交': 'Submit',
    修改成功: 'Modification successful',
  },
  login: {
    用户登录: 'User Login',
    请输入用户名: 'Username',
    密码: 'Password',
    登录: 'Login',
    '没有账户?立即注册': 'No account? Register now',
	
	'未登录或登录过期，请重新登录': 'Not logged in or expired, please log in again',
	'提示': 'Prompt',
	'取消': 'Cancel',
  },
  register: {
    用户注册: 'User Registration',
    '已有账号，去登录': 'Already have an account? Go to login',
    用户名: 'Username',
    邮箱: 'Email',
    密码: 'Password',
    再次输入密码: 'Confirm Password',
    用户类型: 'User Type',
    采购商: 'Purchaser',
    供应商: 'Supplier',
    注册: 'Register',
    请输入用户名称: 'Please enter your username',
    请输入邮箱: 'Please enter your email',
    请输入正确的邮箱格式: 'Please enter a valid email format',
    请输入密码: 'Please enter your password',
    请再次输入密码: 'Please confirm your password',
    请选择用户类型: 'Please select your user type',
  },
  personalCenter: {
    企业认证: 'Enterprise Certification',
    '基本信息（必填）': 'Basic Information (Required)',
    营业执照: 'Business License',
    企业名称: 'Enterprise Name',
    联系人: 'Contact Person',
    邮箱: 'Email',
    联系电话: 'Contact Phone',
    组织机构代码: 'Organization Code',
    企业资质信息: 'Enterprise Qualification Information',
    税务登记证: 'Tax Registration Certificate',
    组织机构代码证: 'Organization Code Certificate',
    开户许可证: 'Account Opening Permit',
    企业资质与能力: 'Enterprise Qualification and Capability',
    行业经营资质: 'Industry Business Qualification',
    生产或代理资质: 'Production or Agency Qualification',
    质量管理体系认证: 'Quality Management System Certification',
    环保与安全资质: 'Environmental and Safety Qualification',
    供货能力证明: 'Supply Capacity Proof',
    售后服务能力证明: 'After-sales Service Capacity Proof',
    产品资质相关: 'Product Qualification Related',
    产品质量检测报告: 'Product Quality Inspection Report',
    产品认证证书: 'Product Certification',
    产品说明书: 'Product Manual',
    其他材料: 'Other Materials',
    信用证明: 'Credit Proof',
    无违规声明: 'No Violation Statement',
    电商平台运营经验证明: 'E-commerce Platform Operation Experience Proof',
    企业荣誉: 'Enterprise Honor',
    其他相关资质或证明材料: 'Other Relevant Qualifications or Certification Materials',
    提交: 'Submit',
    图片或文件: 'Image or file',
    请上传营业执照: 'Please upload the business license',
    请输入企业名称: 'Please enter the enterprise name',
    企业名称长度在2到50个字符之间: 'The length of the enterprise name should be between 2 and 50 characters',
    请输入联系人姓名: "Please enter the contact person's name",
    联系人姓名长度在2到20个字符之间: "The length of the contact person's name should be between 2 and 20 characters",
    请输入邮箱地址: 'Please enter email address',
    请输入联系电话: 'Please enter the contact phone number',
  },
  personalCenter2: {
    企业认证: 'Enterprise Certification',
    '基本信息（必填）': 'Basic Information (Required)',
    '业务信息（必填）': 'Business Information (Required)',
    '联系方式（必填）': 'Contact Information (Required)',
    '资质相关（必填）': 'Qualification Related (Required)',
    企业名称: 'Enterprise Name',
    公司注册地址: 'Company Registration Address',
    公司注册编号: 'Company Registration Number',
    成立时间: 'Establishment Date',
    公司规模: 'Company Scale',
    采购品类: 'Procurement Categories',
    年采购额范围: 'Annual Procurement Amount Range',
    主要采购市场: 'Main Procurement Markets',
    预计月采购量: 'Estimated Monthly Procurement Volume',
    公司邮箱: 'Company Email',
    公司电话: 'Company Phone',
    公司网站: 'Company Website',
    办公地址: 'Office Address',
    公司营业执照: 'Company Business License',
    进出口贸易许可证: 'Import and Export Trade License',
    银行账户证明: 'Bank Account Certificate',
    提交: 'Submit',
    图片或文件: 'Image or file',
    '提交成功，请耐心等待客服审核通过': 'Submission successful. Please wait patiently for customer service review.',
    提示: 'Prompt',
    确定: 'OK',
    取消: 'Cancel',
    '提交失败，请稍后重试': 'Submission failed. Please try again later.',
    请完善必填信息: 'Please complete the required information.',
    请输入企业名称: 'Please enter the enterprise name',
    请输入公司注册地址: 'Please enter the company registration address',
    请输入公司注册编号: 'Please enter the company registration number',
    请选择成立时间: 'Please select the establishment date',
    请选择公司规模: 'Please select the company scale',
    请选择采购品类: 'Please select the procurement categories',
    请选择年采购额范围: 'Please select the annual procurement amount range',
    请选择主要采购市场: 'Please select the main procurement markets',
    请输入预计月采购量: 'Please enter the estimated monthly procurement volume',
    请输入公司邮箱: 'Please enter the company email',
    请输入公司电话: 'Please enter the company phone',
    请输入公司网站: 'Please enter the company website',
    请输入办公地址: 'Please enter the office address',
    请上传公司营业执照: 'Please upload the company business license',
    请上传进出口贸易许可证: 'Please upload the import and export trade license',
    请上传银行账户证明: 'Please upload the bank account certificate',
  },
'solution4':{
    'txt1':'Precision Sensing · Driving the Future of Global Intelligent Manufacturing',
    'txt2':'In high-precision applications like industrial automation, UAV navigation, robotic control, and automotive electronics, gyroscope selection directly impacts device performance and reliability. As a professional industrial cross-border trade platform, we understand the challenges in component selection:',
    'txt3':'Complex parameters: How to match specifications like range, bias stability, and noise with application scenarios',
    'txt4':'Harsh environments: Ensuring stability under extreme temperatures, shock, and vibration',
    'txt5':'Integration difficulties: Optimizing interface compatibility and circuit design',
    'txt6':'Our solution: Leverage the technical advantages of ASG1000 MEMS gyroscopes to provide "precision selection support + full-process technical services", accelerating product integration and mass production',
    'txt7':'Core Advantages of ASG1000 Series',
    'txt8':'Military-grade performance for demanding environments',
    'txt9':'High accuracy: Bias stability as low as 0.5 dph (ASG1100-P5), angular random walk 0.06°/√h, ideal for precision navigation and attitude control',
    'txt10':'Wide temperature operation: -55℃ to +125℃, passing GJB 150.3A/4A temperature tests for extreme industrial environments',
    'txt11':'Shock and vibration resistance: 4000g shock tolerance, 6.06grms vibration reliability, compliant with GJB 150.18A for long-term stability',
    'txt12':'Flexible adaptation for multi-scenario coverage',
    'txt13':'Plug-and-play design for rapid integration',
    'txt14':'Standard SPI interface: Supports ≥2kHz data rate, compatible with mainstream controllers',
    'txt15':'Compact packaging: 11mm×11mm size for space-constrained devices',
    'txt16':'Circuit optimization guidance: Provides pin definitions and capacitor matching suggestions (e.g. 1μF capacitor for V4P5) to shorten development cycles',
    'txt17':'Our Services: Full-process support from selection to mass production',
    'txt18':'Precision selection support',
    'txt19':'Scenario-based matching: Recommend optimal models based on application requirements (range, environment, power consumption)',
    'txt20':'Example: UAV flight control requires high dynamic response - ASG1500 series with 100Hz bandwidth ensures real-time attitude adjustment',
    'txt21':'Parameter comparison analysis: Interpret key indicators like bias repeatability and nonlinearity to mitigate design risks',
    'txt22':'Technology empowerment',
    'txt23':'Reference design package: Includes schematics, PCB layout suggestions, and driver code to accelerate development',
    'txt24':'Customization services: Support OEM/ODM for package optimization or output protocols to meet special needs',
    'txt25':'Quality and supply chain assurance',
    'txt26':'Full-process quality control: Complies with military standards like GJB 548B and GJB 7952, 100% factory inspection',
    'txt27':'Hassle-free global logistics: Worldwide warehouse network with DDP/DAP services ensuring timely delivery',
    'txt28':'Additional advantages',
    'txt29':'Technical credentials',
    'txt30':'Products developed by military-tech team with 10+ years MEMS sensor R&D experience',
    'txt31':'One-stop service',
    'txt32':'Full-process support from component selection, sample testing to bulk purchasing',
    'txt33':'Data transparency',
    'txt34':'Provide third-party test reports (vibration rectification coefficient, temperature drift curves) for assured procurement',

    'tab1': 'Model',
    'tab2': 'Range', 
    'tab3': 'Key Features',
    'tab4': 'Typical Applications',
    'tab5': 'Ultra-low Noise & High Stability',
    'tab6': 'UAV Altitude Hold | Precision Instruments',
    'tab7': 'High Bandwidth (≥100Hz) | Vibration Resistance',
    'tab8': 'Industrial Robots | Autonomous Driving'
},
AddDemand: {
    'xzcgxq': 'Add Purchase Requirement',
    'bjcgxq': 'Edit Purchase Requirement',
    'cpmc': 'Product Name',
    'cplb': 'Product Category',
    'cgsl': 'Purchase Quantity',
    'dw': 'Unit',
    'ysje': 'Budgeted Amount',
    'jhqx': 'Delivery Date',
    'bmjzsj': 'Application Deadline',
    'cpzt': 'Product Main Image',
    'cpxjt': 'Product Detail Images',
    'cpfj': 'Product Attachments',
    'cpyqxq': 'Product Requirements Details',
    'qsr': 'Please enter',
    'qxz': 'Please select',
    'tbdxjt': 'Sync to Detail Images',
    'tj': 'Submit',
    'qsrcpmc': 'Please enter product name',
    'qsrcgsl': 'Please enter purchase quantity',
    'qsrdw': 'Please enter unit',
    'qxzcplb': 'Please select product category',
    'qsrysje': 'Please enter budgeted amount',
    'qsrjhqx': 'Please enter delivery date',
    'qxzbmjzsj': 'Please select application deadline',
    'qsrcpgxq': 'Please enter product specification requirements',
    'qsccpzt': 'Please upload product main image',
    'qsccpxjt': 'Please upload product detail images',
    'xgcg': 'Modified successfully',
    'xzcg': 'Added successfully',
    'hqcgxqxqsb': 'Failed to get purchase requirement details'
},
product: {
    '请先登录后查看产品详情': 'Please log in first to view product details',
    '请先登录后继续操作': 'Please log in first to continue',
    '提示': 'Prompt',
    '去登录': 'Go to Login',
    '取消': 'Cancel'
}
}
export default en_US
